import { render, staticRenderFns } from "./DinnerSchoolList.vue?vue&type=template&id=0703c6aa&scoped=true&"
import script from "./DinnerSchoolList.vue?vue&type=script&lang=js&"
export * from "./DinnerSchoolList.vue?vue&type=script&lang=js&"
import style0 from "./DinnerSchoolList.vue?vue&type=style&index=0&id=0703c6aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0703c6aa",
  null
  
)

export default component.exports